const dataAbout = {
  spanish: {
    title: 'Sobre mí',
    im: 'Me llamo Eduardo, soy ',
    eng: 'Ing. en Ciencias de la Computación',
    text1: '🔥 Tengo una pasión por la programación.',
    text2: '🔥 Creando soluciones a traves de codigo.',
    buttonDetails: 'Detalles',
    buttonBack: 'Regresar',
  },
  english: {
    title: 'About',
    im: "My name is Eduardo, I'm ",
    eng: 'Eng. in Computer Science',
    text1: "🔥 I'm passionate about coding.",
    text2: '🔥 Creating solutions through code.',
    buttonDetails: 'Details',
    buttonBack: 'Back',
  },
};

const dataProject = {
  spanish: {
    title: 'Proyectos',
    labelRepository: 'Repositorio',
  },
  english: {
    title: 'Projects',
    labelRepository: 'Repository',
  },
};

const dataSkill = {
  spanish: {
    title: 'Tecnologías',
    text: 'Credencial',
  },
  english: {
    title: 'Skills',
    text: 'Credential',
  },
};

const dataContact = {
  spanish: {
    title: 'Contacto',
    msgSuccess: 'Mensaje enviado',
    msgError: 'Error al enviar mensaje',
    labelName: 'Nombre',
    labelEmail: 'Correo',
    labelSubject: 'Asunto',
    labelMessage: 'Mensaje',
    textButtonSend: 'Enviar',
    textButtonCV: 'Mi CV',
  },
  english: {
    title: 'Contact',
    msgSuccess: 'Message sent',
    msgError: 'Error sending message',
    labelName: 'Name',
    labelEmail: 'Email',
    labelSubject: 'Subject',
    labelMessage: 'Message',
    textButtonSend: 'Send',
    textButtonCV: 'My CV',
  },
};

export {
  dataAbout,
  dataProject,
  dataSkill,
  dataContact,
};
